import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import { Select } from 'support/fields'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { Translation } from '@morningtrain/react-translations'

function ToggleBreakOptions () {
  const durationInMinutes = useValue('current_toggle_duration', 0) / 60
  const [breakDuration, setBreak] = useEnvValue('toggle.break', 0)

  const options = []
  let dt = 0

  while (durationInMinutes >= dt && dt <= 120) {
    options.push({
      value: dt,
      label: dt + ' min'
    })
    dt += 5
  }

  const updateBreakDuration = (e) => {
    setBreak(e)
  }

  return (
    <Select
      className='w-28'
      name='break'
      options={options}
      defaultValue={0}
      onChange={updateBreakDuration}
    />
  )
}

export default observer(ToggleBreakOptions)
